import { render } from "./yos-pager.vue?vue&type=template&id=c4704788"
import script from "./yos-pager.vue?vue&type=script&lang=js"
export * from "./yos-pager.vue?vue&type=script&lang=js"

import "./yos-pager.vue?vue&type=style&index=0&id=c4704788&lang=postcss"
script.render = render

export default script